/* eslint-disable react/no-multi-comp */
import { AutoFillIcon, CircleCloseIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

export interface IAutoFillFeatureItem {
  id: string;
  title: string;
  description: string;
  Icon: FC<React.SVGProps<SVGSVGElement>>;
}

export interface IAutoFillFeatures {
  title: string;
  list: IAutoFillFeatureItem[];
}

interface AutoFillFeatureInfoModalProps {
  open: boolean;
  onClose: VoidFn;
  onGotIt: VoidFn;
  features: IAutoFillFeatures;
}

interface FeatureInfoRowProps {
  feature: IAutoFillFeatureItem;
}

const FeatureInfoRow: FC<FeatureInfoRowProps> = ({ feature }) => {
  const { Icon } = feature;
  return (
    <div className="flex">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondaryBtn" aria-hidden>
        <Icon className="h-[23px] w-[23px]" />
      </div>
      <div className="ml-4 flex flex-col">
        <div className="mb-1 text-sbase font-semibold text-heading">{feature.title}</div>
        <div className="text-sbase font-normal text-primaryText">{feature.description}</div>
      </div>
    </div>
  );
};

const AutoFillFeatureInfoModal: FC<AutoFillFeatureInfoModalProps> = ({ open, onClose, onGotIt, features }) => {
  const handleGotIt = () => {
    onGotIt();
  };

  return (
    <CustomModal
      enableOutsideClick={false}
      closeModal={onClose}
      open={open}
      backgroundColor="bg-primary"
      height="max-h-[90%]"
      width="w-[395px] max-w-[482px] w-[90%] md:w-[482px]"
      className="overflow-auto">
      <div className="relative flex h-full w-full grow flex-col">
        <CircleCloseIcon
          className="absolute top-2 right-2 z-[1] shrink-0 cursor-pointer"
          onClick={onClose}
          aria-label="Close modal"
        />
        <div className="customTransparentScroll flex flex-col overflow-auto px-10 py-[33px]">
          <div
            className={'mx-auto mb-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-secondaryBtn'}>
            <AutoFillIcon className="mr-1.5 h-8 w-8 shrink-0" aria-hidden />
          </div>
          <div className="mx-auto mb-8 text-center text-xl font-bold text-heading">{features?.title}</div>
          <div className="flex flex-col space-y-4">
            {features?.list?.map(feature => (
              <FeatureInfoRow feature={feature} key={feature.id} />
            ))}
          </div>
          <CustomButton
            className="mt-9 h-[38px] w-full shrink-0"
            id="autofill-feature-info-got-it-btn"
            type={ButtonType.PRIMARY}
            onClick={handleGotIt}>
            Got it
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default AutoFillFeatureInfoModal;
